import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';

import { catchError, switchMap } from 'rxjs/operators';
import { Observable, from } from 'rxjs';

import { DISABLE_HTTP_ERROR_NORMALIZATION } from '@lentau/api/shared/shared/http-error.tokens';

export function httpErrorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const injector: Injector = inject(Injector);

  if (req.context.get(DISABLE_HTTP_ERROR_NORMALIZATION)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((errorResult: HttpErrorResponse) => {
      return from(import('./http-error.handler')).pipe(
        switchMap(({ handleHttpError }) => handleHttpError(errorResult, injector))
      );
    })
  );
}

export const CART_NOTICE_REQUESTS: string[] = [
  'cartItemModify',
  'cartItemMultiDelete',
  'cartItemAdd',
  'cartFromOrderAdd',
];

export function httpNoticesInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const injector: Injector = inject(Injector);

  const isCartNoticeRequest: boolean = CART_NOTICE_REQUESTS.some((path: string): boolean => req.url.includes(path));

  if (!isCartNoticeRequest) {
    return next(req);
  }

  return next(req).pipe(
    switchMap((event: HttpEvent<unknown>) =>
      from(import('./http-notices.handler')).pipe(
        switchMap(({ httpNoticesInterceptor }) => httpNoticesInterceptor(event, injector))
      )
    )
  );
}
